<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">摄像头设备</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input 
              v-model="queryParams.equipmentName" 
              placeholder="请输入设备名称">
            </el-input>
          </el-form-item>

          <el-form-item label="区域" prop="areaCode">
            <treeselect
              v-model="queryParams.areaCode"
              :options="regionData"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>

          <el-form-item label="是否在线" prop="onlineStatus">
            <el-select v-model="queryParams.onlineStatus" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option key label="在线" value="1"></el-option>
              <el-option key label="离线" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备类型" prop="categoryCode">
            <treeselect
              v-model="queryParams.categoryCode"
              :options="equipmentTypeList"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <!-- <el-button @click="onAdd">新 增</el-button> -->
            <el-button @click="onTongMonitor">同步监控设备</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="monitorEquipmentList"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
              <el-table-column prop="areaCodeTranslated" label="区域"></el-table-column>
              <el-table-column prop="categoryCodeTranslated" label="设备类型"></el-table-column>
              <el-table-column prop="longitude" label="经度"></el-table-column>
              <el-table-column prop="latitude" label="纬度"></el-table-column>
              <el-table-column prop="onlineStatus" label="设备状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 2" style="color: red">离线</span>
                  <span v-if="scope.row.onlineStatus == 1" style="color: green">在线</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { getEquipmentCode, listEquipment, delEquipment, listEquipmentCategory } from "@/api/src/equipment";
import { listEquipmentAreaTree } from "@/api/src/equipmentArea";
import { monitorTong } from "@/api/src/equipment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "MonitorEquipmentView",
  controller: "UI",
  action: "MonitorEquipmentView",
  components: {
    Treeselect
  },
  data() {
    return {
      // 设备类型
      code: '',
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        equipmentName: '',
        areaCode: null,
        onlineStatus: null,
        categoryCode: null,
        pageNum: 1,
        pageSize: 10
      },
      // 区域数据
      regionData: [],
      // 设备类型数据
      equipmentTypeList: [],
      // 表格数据
      monitorEquipmentList: [],
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.init();
      this.getAreaTree();
    });
  },
  methods: {
    // 查询区域树
    getAreaTree(){
      listEquipmentAreaTree().then(response =>{
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionData = response.data.map(obj => mapTree(obj));
      });
    },
    // 获取设备code
    init(){
      getEquipmentCode('monitorEquipment').then(response =>{
        this.code = response.data;
        this.queryParams.categoryCode = this.code;
        this.getList();
        this.getEquipmentTypeList();
      });
    },
    // 查询设备分类列表
    getEquipmentTypeList(){
      listEquipmentCategory({parentCode: this.code}).then(response =>{
        this.equipmentTypeList = this.handleTree(response.rows, "id", "pid");
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.categoryCode,
            label: obj.categoryName,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.equipmentTypeList = this.equipmentTypeList.map(obj => mapTree(obj));
      });
    },
    // 查询
    getList() {
      this.loading = true;
      listEquipment(this.queryParams).then(response =>{
        this.monitorEquipmentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.queryParams.categoryCode = this.code;
      this.onSearch();
    },
    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/MonitorEquipmentInfo",
        query: { areaTree: this.regionData, typeList: this.equipmentTypeList, categoryCode: this.code, type: "add"},
      });
    },
    onTongMonitor() {
      // monitorTong().then(res=>{
      //   console.log("视频同步接口")
      //   console.log(res)
      // })
      const that = this;
      this.loading = true;
      let tongbuCode = "";
      if(that.monitorEquipmentList.length==0){
        this.loading = false;
        return 
      }else{
        tongbuCode = that.monitorEquipmentList[0].equipmentNo;
      }
      axios({
        method: "get",
        url: this.CNF("api.monitorGBUrl") + `/device/query/devices/${tongbuCode}/sync`, 
      })
        .then(function (res) {
          console.log("同步流信息", res);
          if (res.data.code == 0) {
            that.loading = true;
            that.loadMsg = res.data.msg;
            setTimeout(function(){
               that.onSearch()
            },6000)
          } else {
            that.loading = false;
            that.$message.error(res.data.msg);
            that.loadMsg = res.data.msg;
          }
        })
        .catch(function (e) {
          console.error(e);
          that.loadStatus = true;
          that.loadMsg = e.msg ? e.msg : "取流失败";
        });
    },
    // 行查看
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/MonitorEquipmentInfo",
        query: { areaTree: this.regionData, typeList: this.equipmentTypeList, categoryCode: this.code, id: row.id, type: "query" },
      });
    },
    // 行编辑
    editDetail(row) {
      this.$router.push({
        path: "/plugin/equipment/ui/MonitorEquipmentInfo",
        query: { areaTree: this.regionData, typeList: this.equipmentTypeList, categoryCode: this.code, id: row.id, type: "edit" },
      });
    },
    // 行删除
    deleteClick(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delEquipment({id:row.id});
      }).then(() => {
        this.$message({type: "success", message: "删除成功!"});
        this.getList();
      }).catch(() => {});
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px !important;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__menu{
  border-radius: 0px;
}
</style>
